import { LoyaltyMembership } from '@mews-commander/data-access';
import { LoyaltyMembershipsRecord } from '../../types';
import { DividedList } from './DividedList';
import { AccountLoyalty } from './AccountLoyalty';

interface CompanionLoyaltyListProps {
    companionIds: string[];
    handleLoyaltyMembershipsClick: (
        event: React.MouseEvent<HTMLAnchorElement>,
        loyaltyMemberships: Array<LoyaltyMembership>
    ) => void;
    loyaltyMembershipsRecord: LoyaltyMembershipsRecord;
}

export const CompanionLoyaltyList = ({
    companionIds,
    loyaltyMembershipsRecord,
    handleLoyaltyMembershipsClick,
}: CompanionLoyaltyListProps) => (
    <DividedList
        collectionIds={companionIds}
        renderItem={(id) => {
            const loyaltyMemberships = loyaltyMembershipsRecord[id];

            if (!loyaltyMemberships) return null;

            return (
                <AccountLoyalty
                    loyaltyMemberships={loyaltyMemberships}
                    onClick={(e) => handleLoyaltyMembershipsClick(e, loyaltyMemberships)}
                />
            );
        }}
    />
);
